import { jarallax } from 'jarallax';
import { readingTime } from 'reading-time-estimator';
import lightGallery from 'lightgallery';
import lgVideo from 'lightgallery/plugins/video';

window.addEventListener('resize', function (e) {
  console.log(window.innerWidth);
});

window.addEventListener('scroll', function () {
  const headerEl = this.document.querySelector('.header');
  const secTovar = this.document.querySelector('.sec-tovar');

  setTimeout(() => {
    if (window.pageYOffset > 0) {
      headerEl.classList.add('shadow');
    } else {
      headerEl.classList.remove('shadow');
    }
  }, 0);

  if (secTovar) {
    setTimeout(() => {
      if (window.pageYOffset > 0 && secTovar) {
        secTovar.classList.add('active');
      } else {
        secTovar.classList.remove('active');
      }
    }, 0);
  }
});

jarallax(document.querySelectorAll('.sec-card__bg'));
jarallax(document.querySelectorAll('.sec-article'), {
  speed: 0.2,
});

document.addEventListener('DOMContentLoaded', function () {
  if (document.querySelector('[data-readtime]')) {
    const text = document.querySelector('[data-readblock]').textContent;
    const result = readingTime(text, 10, 'en');
    let answer = '';

    if (result.minutes < 1) {
      answer = 'Меньше минуты';
    } else if (5 <= result.minutes <= 20) {
      answer = result.minutes + ' минут';
    } else if (String(result.minutes).endsWith('1')) {
      answer = result.minutes + ' минута';
    } else if (
      String(result.minutes).endsWith('2') ||
      String(result.minutes).endsWith('3') ||
      String(result.minutes).endsWith('4')
    ) {
      answer = result.minutes + ' минуты';
    } else {
      answer = result.minutes + ' минут';
    }
    document.querySelector('[data-readtime]').textContent = answer;
  }

  if (document.querySelector('[data-show-search]')) {
    document
      .querySelector('[data-show-search]')
      .addEventListener('click', showSearchBar);

    document
      .querySelector('.sec-search .form-search__input')
      .addEventListener('blur', hideSearchBar);
  }

  if (document.querySelector('[data-hide-search]')) {
    document
      .querySelector('[data-hide-search]')
      .addEventListener('click', hideSearchBar);
  }

  if (document.querySelector('.btn-burger')) {
    document
      .querySelector('.btn-burger')
      .addEventListener('click', clickBurger);
  }

  if (document.querySelector('[data-close-nav]')) {
    document.querySelectorAll('[data-close-nav]').forEach((element) => {
      element.addEventListener('click', closeNav);
    });
  }

  if (document.querySelector('.card-tovar')) {
    onMobileTovarToCart();
  }

  if (document.querySelector('[data-relocate]')) {
    relocateListen();
  }

  createScrollbarWidth();

  // Ленивая загрузка для заднего фона
  const lazyBackgrounds = [].slice.call(
    document.querySelectorAll('.lazy-background')
  );

  if ('IntersectionObserver' in window) {
    let lazyBackgroundObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');

          entry.target.style.backgroundImage = entry.target.dataset.bgimg;

          lazyBackgroundObserver.unobserve(entry.target);
        }
      });
    });

    lazyBackgrounds.forEach(function (lazyBackground) {
      lazyBackgroundObserver.observe(lazyBackground);
    });
  }

  const sliderProducts = new Swiper('.slider-products', {
    loop: true,

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

  const sliderBanner = new Swiper('.slider-banner', {
    loop: true,
    autoplay: {
      delay: 5000,
    },

    pagination: {
      el: '.swiper-pagination',
    },

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

  const sliderChanger = new Swiper('.slider-changer', {
    watchSlidesProgress: true,

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

  sliderChanger.on('slideChange', function () {
    const colorTarget =
      sliderChanger.slides[sliderChanger.activeIndex].dataset.color;
    const targetBtn = document.querySelector(
      `[data-colortrigger=${colorTarget}]`
    );

    document.querySelectorAll('[data-colortrigger]').forEach((element) => {
      element.classList.remove('active');
    });

    targetBtn.classList.add('active');
  });

  if (document.querySelector('[data-colortrigger]')) {
    document.querySelectorAll('[data-colortrigger]').forEach((element) => {
      element.addEventListener('click', startSliderChanger);
    });
  }

  function startSliderChanger() {
    document.querySelectorAll('[data-colortrigger]').forEach((element) => {
      element.classList.remove('active');
    });

    this.classList.add('active');
    const colorTarget = this.dataset.colortrigger;

    sliderChanger.slides.forEach((slide, i) => {
      if (slide.dataset.color === colorTarget) {
        sliderChanger.slideTo(i);
      }
    });
  }

  if (document.querySelector('.ms2_form')) {
    document.querySelectorAll('.ms2_form').forEach((element) => {
      element.addEventListener('submit', ms2AddedSubmit);
    });
  }

  if (
    document.querySelector('.sec-buy-together__item') &&
    document.querySelector('input[name=id]')
  ) {
    checkDoubleItems();
  }

  if (document.querySelector('.lightgallery')) {
    document.querySelectorAll('.lightgallery').forEach((el) => {
      lightGallery(el, {
        plugins: [lgVideo],
        licenseKey: '0000 0000 0000 0000',
        speed: 500,
        counter: false,
        download: false,
        loadYouTubePoster: true,

        youTubePlayerParams: {
          //showinfo: 0,
          //controls: 1,
          autoplay: 1,
          color: 'white',
          rel: 0,
          mute: 0,
        },
      });
    });
  }

  if (document.querySelector('#msOrder')) {
    listenDeliveryInputs();
  }
});

window.showPopupAddedToCart = () => {
  document.querySelector('.popup-added-to-cart').classList.add('active');
  document.querySelector('.overlay').classList.add('active');
};

function checkDoubleItems() {
  const allItems = document.querySelectorAll('.sec-buy-together__item');
  const mainId = document.querySelector('.ms2_form input[name=id]').value;

  allItems.forEach((element) => {
    if (element.dataset.id === mainId) {
      element.classList.add('dn');
    }
  });
}

function ms2AddedSubmit(e) {
  const counterEl = document.querySelector('.shop-cart__counter');
  const valueEl = document.querySelector('.shop-cart__value');

  setTimeout(() => {
    if (Number(counterEl.textContent) > 0 || Number(valueEl.textContent) > 0) {
      document.querySelector('.shop-cart').classList.remove('empty');
    }
  }, 500);

  const btnSumbitToCard = e.target.querySelector('[name=ms2_action]');
  console.log(btnSumbitToCard);
  //if (window.location.pathname !== '/cart.html') {
  if (btnSumbitToCard && btnSumbitToCard.value === 'cart/add') {
    document.querySelector('.popup-added-to-cart').classList.add('active');
    document.querySelector('.overlay').classList.add('active');
  }
}

function relocateListen() {
  document.querySelectorAll('[data-relocate]').forEach((element) => {
    element.addEventListener('change', changeRelocate);
  });
}

function changeRelocate(e) {
  window.location.href = e.target.value;
}

function onMobileTovarToCart() {
  const card = document.querySelector('.card-tovar');
  const cardForm = card.querySelector('form');
  const cardTitle = card.querySelector('.card-tovar__title');
  // const cardBtn = card.querySelector('.card-tovar__btn');

  cardTitle.addEventListener('click', () => {
    if (!window.matchMedia('(min-width: 768px)').matches) {
      //cardBtn.click();

      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  });
}

function clickBurger(e) {
  e.preventDefault();

  const nav = document.querySelector('[data-navigation]');
  const secCardBgEl = document.querySelector('.sec-card__bg');

  if (secCardBgEl) {
    nav.style.backgroundImage = secCardBgEl.dataset.bgimg;
  }

  this.classList.toggle('active');

  if (document.querySelector('[data-show-search]')) {
    document.querySelector('[data-show-search]').classList.toggle('hide');
  }

  nav.classList.toggle('active');
  popupDoNavFreeze();
}

function closeNav() {
  document.querySelector('.btn-burger').click();
}

function showSearchBar(e) {
  if (e) {
    e.preventDefault();
  }

  const secSearchEl = document.querySelector('.sec-search');
  secSearchEl.classList.add('active');
  secSearchEl.querySelector('.form-search__input').value = '';
  secSearchEl.querySelector('.form-search__input').focus();
}

function hideSearchBar(e) {
  if (e) {
    e.preventDefault();
  }

  const secSearchEl = document.querySelector('.sec-search');

  setTimeout(() => {
    secSearchEl.classList.remove('active');
    secSearchEl.querySelector('.no-results').classList.add('d-none');
    secSearchEl.querySelector('.form-search__input').blur();
  }, 300);
}

function createScrollbarWidth() {
  const html = document.querySelector('html');
  const scrollDiv = document.createElement('div');
  scrollDiv.style.cssText =
    'width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;';
  document.body.appendChild(scrollDiv);
  const scrollBarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);
  html.style.setProperty('--scrollbar-width', `${scrollBarWidth}px`);
}

function popupDoNavFreeze() {
  const html = document.querySelector('html');

  createScrollbarWidth();

  html.classList.toggle('freeze');
  html.classList.toggle('nav-slide');
}

function popupDoFreeze() {
  const html = document.querySelector('html');
  html.classList.toggle('freeze');
}

function listenDeliveryInputs() {
  document.querySelectorAll('input[name=delivery]').forEach((element) => {
    element.addEventListener('change', deliveryHandler);
  });

  if (document.querySelector('#delivery_11').checked) {
    document.querySelector('#deliveryAddress').classList.remove('d-none');
    document.querySelector('#trigger-pvz').classList.remove('d-none');
  }
}

function deliveryHandler(e) {
  /**
    Легенда:
    1 - это самовывоз,
    11 - это доставка СДЭК в ПВЗ.
  */
  const deliveryAddressEl = document.querySelector('#deliveryAddress');
  const triggerPvzEl = document.querySelector('#trigger-pvz');

  if (e.target.value == '1') {
    deliveryAddressEl.classList.add('d-none');
    triggerPvzEl.classList.add('d-none');
  } else if (e.target.value == '11') {
    deliveryAddressEl.classList.remove('d-none');
    triggerPvzEl.classList.remove('d-none');
    window.cdekWidget.open();
  }
}
